interface HttpRequestOptions {
  withCredentials: boolean;
}

export class HttpRequest {
  get(url: string, options: HttpRequestOptions = { withCredentials: false }) {
    return fetch(url, {
      method: 'get',
      credentials: options.withCredentials ? 'include' : 'omit',
    });
  }

  fetchJSON = async (request: string) => {
    try {
      const response = await fetch(request);
      const contentType = response.headers.get('content-type');
      if (!contentType || !contentType.includes('application/json')) {
        throw new TypeError("Oops, we haven't got JSON!");
      }
      const jsonData = await response.json();
      return jsonData;
    } catch (error) {
      throw new Error('There was an error in the call!');
    }
  };
}
